import { useRef, useState } from "react";
import { CalendarPicker } from "..";
import { getDateInf } from "../action";
import "./calendarWeb.scss";

export default function CalendarWeb() {
  const calendarWrapRef = useRef<HTMLDivElement>(null);

  const [now, setNow] = useState<Date>(new Date());
  const { today } = getDateInf(new Date());

  const nextNow = new Date(now.getFullYear(), now.getMonth() + 2, 0);

  const handlePrev = () => {
    const prevNow = new Date(now.getFullYear(), now.getMonth() - 1, 0);
    setNow(prevNow);
  };
  const handleNext = () => {
    const nextNow = new Date(now.getFullYear(), now.getMonth() + 3, 0);
    setNow(nextNow);
  };

  // //OUTSIDE CLICK
  // const outSideClick = (e: any) => {
  //   if (
  //     calendarWrapRef.current &&
  //     !calendarWrapRef.current.contains(e.target) &&
  //     calendarWrapRef.current
  //   ) {
  //     setDateRange([]);
  //     // setDates([]);
  //     // items.forEach((day) => {
  //     //   day.removeAttribute("is-start");
  //     //   day.removeAttribute("is-end");
  //     // });
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mouseout", outSideClick);

  //   return () => {
  //     document.removeEventListener("mouseout", outSideClick);
  //   };
  // }, []);

  const isPrevBtn =
    today === now.toISOString().split("T")[0].replaceAll("-", "");

  return (
    <>
      <div
        className="center mt-[2rem] mb-[2.5rem] relative"
        ref={calendarWrapRef}
      >
        {!isPrevBtn && (
          <button className="btn-icon-prev" onClick={handlePrev} />
        )}
        <CalendarPicker now={now} styles="calendar-web me-5" />
        <CalendarPicker now={nextNow} styles="calendar-web" />
        <button className="btn-icon-next" onClick={handleNext} />
      </div>
    </>
  );
}
